<template>
  <div class="d-none d-md-block pb-5">
    <div class="desktop-app-wrapper">
      <div class="category-list">
          <!-- <div class="category"
          :class=" selectedCategory === -1 ? 'active' : '' "
          @click="setCategory(-1)">
            All Projects
          </div> -->
          <div
            class="category"
            :class="index === selectedCategory ? 'active' : ''"
            v-for="(category, index) in projects"
            :key="index" @click="setCategory(index)"
          >
            {{category?.name}}
          </div>
      </div>
      <div class="projects">
        <template v-for="(project, index) in projects[selectedCategory]?.projects" :key="index">
          <div class="project" v-if="index >= (showingPage * 4 - 4 ) && index < (showingPage * 4)">
            <a :href="project.permalink">
                <div class="project-content">
                  <div class="image" :style="'background-image: url(' + project?.gallery[0] + ');'"></div>
                  <div class="gradient"></div>
                  <div class="text">
                      <div class="category">{{ project.category ?? projects[selectedCategory]?.name }}</div>
                      <div class="project-name">{{project.title}}</div>
                  </div>
                </div>
            </a>
          </div>
        </template>
      </div>
      <div class="page-control">
          <div class="prev ns" @click="prevPage">
            <font-awesome-icon :icon="['fa', 'chevron-left']" />
          </div>
          <div class="number"><span class="current-number">{{showingPage}}</span><span> / {{ Math.ceil( (projects[selectedCategory]?.projects.length) / 4 ) }}</span></div>
          <div class="next ns" @click="nextPage">
            <font-awesome-icon :icon="['fa', 'chevron-right']" />
          </div>
      </div>

    </div>
  </div>

  <div class="d-block d-md-none">
    <div class="mobile-app-wrapper">
      <div class="app h-100 d-flex flex-column p-0 m-0">
        <div class="row h-25">
          <div class="selector col-12">
              <div class="select">
                <select @change="setCategory( parseInt($event.target.value) )">
                  <template
                  v-for="(category, index) in projects"
                  :key="index">
                    <option :value="index" :selected="index === selectedCategory" >{{category?.name}}</option>
                  </template>
                </select>
                <font-awesome-icon :icon="['fa', 'caret-down']" class="text-white" />
              </div>
          </div>
        </div>
        <div class="row flex-grow-1">
          <div class="projects col-12">
              <div class="project-item project" :style="'background-image: url(' + projects[selectedCategory]?.projects[showingProject]?.gallery?.[0] + ');'">
                <div class="project-item--content">
                    <div class="mask"></div>
                    <h2>{{projects[selectedCategory]['projects'][showingProject]?.title}}</h2>
                    <a :href="projects[selectedCategory]['projects'][showingProject]?.permalink" class="view">
                    VIEW
                    </a>
                </div>
              </div>
              <div class="controller">
                <div class="arrow" @click="prevProject">
                    <font-awesome-icon :icon="['fa', 'chevron-left']" class="text-white" />
                </div>
                <h4>{{showingProject + 1}}/{{projects[selectedCategory]?.projects.length}}</h4>
                <div class="arrow" @click="nextProject">
                    <font-awesome-icon :icon="['fa', 'chevron-right']" class="text-white" />
                </div>
              </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'App',
  data() {
    return{
      selectedCategory: 0,
      showingPage: 1,
      showingProject: 0,
      projects:[],
      pageLang: 'en',
      currentURL: document.URL,
    }
  },
  components: {},
  methods: {
    setCategory: function(cate_arr_id){
      this.selectedCategory = cate_arr_id;
      this.showingPage = 1;
      this.showingProject = 0;
      console.log(this.projects[this.selectedCategory]['projects'])
    },
    prevPage: function() {
      if ( this.showingPage - 1 < 1 ) {
        this.showingPage = 1;
      }else{
        this.showingPage--;
      }
    },
    nextPage: function(){
      let max = Math.ceil( (this.projects[this.selectedCategory]?.projects.length) / 4 );
      if ( this.showingPage + 1 >= max ) {
        this.showingPage = max;
      }else{
        this.showingPage++;
      }
    },
    prevProject: function(){
      if( this.showingProject > 0 ) this.showingProject--;
    },
    nextProject: function(){
      let max = this.projects[this.selectedCategory]?.projects.length;
      if( this.showingProject < max - 1 ) this.showingProject++;
    },
    async setParams() {
      this.currentURL = ((this.currentURL).slice(-1) === "/") ? this.currentURL : this.currentURL + "/";
      let get_params = {
        lang: this.pageLang
      }
      let url_arr = this.currentURL.split("/");

      // Checking vaild language
      let accept_lang = ['en', 'zh-hans'];
      let isVaildLang = accept_lang.filter(element => element.includes(url_arr[3]));
      if (isVaildLang.length > 0){
        this.pageLang = url_arr[3];
        get_params.lang = url_arr[3];
        console.log('Support language found: ' + this.pageLang);
      }
      return get_params;
    },
  },
  // Fetches posts when the component is created.
  async created() {
    try {
      let get_params = await this.setParams();
      const response = await axios.get('https://cmpgroups.com/wp-json/api/v1/getDevelopmentProjects', { params : get_params })
      this.projects = response.data
    } catch (e) {
      this.errors.push(e)
    }
  }
}
</script>

<style scoped>
@import './assets/css/newstyles.css';
@import './assets/css/bootstrap.pick.css';
</style>
